module.exports = __webpack_public_path__ + "h5/img/cygn14.a7d252e6.png";